<template>
  <div
    v-if="isShowBodyPain"
    class="body-pain">
    <h4 class="body-pain__heading">
      体の痛み
    </h4>
    <p class="body-pain__text">
      {{ hasText ? 'あり' : 'なし' }}
    </p>
    <div v-if="hasText">
      <h4 class="body-pain__heading mt-3">
        痛みの詳細
      </h4>
      <p class="body-pain__text detail">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true
    },
    bodyPainSetting: {
      type: Object,
      default: null
    },
  },
  computed: {
    isShowBodyPain() {
      if (this.bodyPainSetting === null) return false
      return this.bodyPainSetting.isRecordBodyPain
    },
    text() {
      if (this.activity.bodyPain === null) return ''
      return this.activity.bodyPain.text
    },
    hasText() {
      return this.text !== ''
    },
  },
}
</script>

<style lang="scss" scoped>
.body-pain {
  margin-bottom: 10px;
  &__heading {
    font-size: $fs-m;
    font-weight: bold;
    padding-bottom: 5px;
  }
  &__text {
    font-size: $fs-m;
    background: $text-background;
    padding: 5px 10px;
    display: inline-block;

    &.detail {
      width: 100%;
    }
  }
}
</style>